import React, { Dispatch, SetStateAction, useState } from "react"
import Head from "next/head"
import { FC } from "react"
import { DashboardSidebar } from "@/components"
import { Header } from "@/components/general/Header"
import dynamic from "next/dynamic"
import { UserIcon } from "@heroicons/react/24/outline"
import { Geo, Quote } from "@/lib/types"
import { DashboardContext } from "@/lib/context/DashboardContext"

type Props = {
  padding?: string
  title: string
  mexico?: boolean
  quote?: Quote
  mexicoMarketData?: {
    mexicoMarket: string | undefined
    bound: string | undefined
  }
  isSuccess?: boolean
  setMexico?: Dispatch<SetStateAction<boolean>>
  handleForm?: (form: Quote) => void
  geoLocations?: {
    origin: Geo["geoLocations"]
    destination: Geo["geoLocations"]
  }
  setSelectedUserId?: Dispatch<SetStateAction<string>>
  children: JSX.Element | JSX.Element[]
}

const SideBar = dynamic(
  () => import("@/components/Dashboard/DashboardSidebar"),
  {
    loading: () => <DashboardSidebar />,
    ssr: false,
  },
)

const Navbar = dynamic(() => import("@/components/general/Header"), {
  loading: () => (
    <Header
      title="Customer"
      role="CUSTOMER"
      icon={UserIcon}
      salesRepId={""}
      slug={"customerID"}
      setId={() => { }}
    />
  ),
  ssr: false,
})

export const DashboardLayout: FC<Props> = (props) => {
  const [salesRepId, setSalesRepId] = useState("")
  const [customerID, setCustomerID] = useState("")
  const [selectedUser, setSelectedUser] = useState<any>({})

  const year = new Date().getFullYear()

  return (
    <DashboardContext.Provider value={{ salesRepId, setSalesRepId, customerID, setCustomerID, selectedUser, setSelectedUser }}>
      <>
        <Head>
          <title>{"BRONCO - " + props.title}</title>
          <link rel="bronco icon" href="/bronco.png" />
        </Head>
        <SideBar />
        <div className=" flex flex-col h-screen bg-primary-21 dark:bg-secondary-6">
          <Navbar
            title="Customer"
            role="CUSTOMER"
            quote={props.quote}
            icon={UserIcon}
            salesRepId={salesRepId}
            slug={"customerID"}
            isSuccess={props.isSuccess}
            setId={setCustomerID}
            mexico={props.mexico}
            geoLocations={props.geoLocations}
            setMexico={props.setMexico}
            mexicoMarketData={props.mexicoMarketData}
            handleForm={props.handleForm}
            setSelectedUserId={props.setSelectedUserId}
            setSelectedUser={setSelectedUser}
          />
          <div className="dashboard-body dark:bg-primary-1 bg-primary-22 ml-auto relative overflow-x-hidden">
            <div className={" " + props.padding}>{props.children}</div>
          </div>
          <div className="dark:bg-primary-1 border-t-2 dark:border-secondary-10 copy-right ml-auto text-center h-16 pt-6 pb-5 mt-auto relative z-[1]">
            <p className="dark:text-primary-7 text-light-2 text-sm">
              &#169; {year} BRONCO TRANSPORTATION
            </p>
          </div>
        </div>
      </>
    </DashboardContext.Provider>
  )
}

DashboardLayout.defaultProps = {
  padding: "2xl:p-6 p-4",
}
